/**
 * Hook that wraps useApi to automatically inject the delegation headers for
 * API calls made on behalf of a reporting target.
 *
 * Sends BOTH headers because v1 reads `x-act-as-prof-id` and v2 reads
 * `x-acting-for`. Sending both keeps the call site agnostic to which API
 * version the endpoint targets.
 */

import { useCallback } from "react";
import { useApi } from "@/shared/utils/request";

export function useReportingApi(targetProfId: string | null) {
  const { makeApiRequest } = useApi();

  const makeReportingRequest = useCallback(
    (options: {
      endpoint: string;
      method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
      body?: unknown;
      headers?: Record<string, string>;
    }) => {
      const headers: Record<string, string> = { ...options.headers };
      if (targetProfId) {
        headers["x-act-as-prof-id"] = targetProfId;
        headers["x-acting-for"] = targetProfId;
      }
      return makeApiRequest({ ...options, headers });
    },
    [makeApiRequest, targetProfId],
  );

  return { makeReportingRequest };
}
